export default "__VITE_ASSET__55852e38__"